import { render, staticRenderFns } from "./RecommendationInfoModal.vue?vue&type=template&id=7c7e2200&scoped=true&"
import script from "./RecommendationInfoModal.vue?vue&type=script&lang=ts&"
export * from "./RecommendationInfoModal.vue?vue&type=script&lang=ts&"
import style0 from "./RecommendationInfoModal.vue?vue&type=style&index=0&id=7c7e2200&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e2200",
  null
  
)

export default component.exports